import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EarningsCalculator from "../components/EarningsCalculator";
import "./ForOwnersPage.css";

export default function ForOwnersPage() {
  const navigate = useNavigate();
  const WA_NUM = "355694343590";

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="fo-page">

      {/* HERO */}
      <section className="fo-hero">
        <div className="fo-hero-bg" />
        <div className="fo-hero-noise" />
        <div className="fo-hero-inner">
          <div className="fo-eyebrow">
            <span className="fo-eyebrow-dot" />
            For property owners · Albania
          </div>
          <h1 className="fo-hero-title">
            Your property.<br />
            Our <em>expertise.</em><br />
            Their stay.
          </h1>
          <p className="fo-hero-sub">
            We handle everything — professional photography, listings, guest communication,
            pricing and check-ins. You collect the earnings, we do the work.
          </p>
          <div className="fo-hero-stats">
            <div className="fo-hstat">
              <span className="fo-hstat-num">10%</span>
              <span className="fo-hstat-label">Our fee only</span>
            </div>
            <div className="fo-hstat-sep" />
            <div className="fo-hstat">
              <span className="fo-hstat-num">24/7</span>
              <span className="fo-hstat-label">Guest support</span>
            </div>
            <div className="fo-hstat-sep" />
            <div className="fo-hstat">
              <span className="fo-hstat-num">0€</span>
              <span className="fo-hstat-label">Setup cost</span>
            </div>
          </div>
          <a className="fo-hero-scroll" href="#calculator">
            Estimate your earnings
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
          </a>
        </div>
      </section>

      {/* WHAT WE DO */}
      <section className="fo-services">
        <div className="fo-container">
          <div className="fo-section-eyebrow">What we handle</div>
          <h2 className="fo-section-title">Everything, so you don't have to</h2>
          <div className="fo-services-grid">
            {[
              ["📸", "Professional photography", "We shoot and style your property at no extra cost — the photos that get bookings."],
              ["💬", "24/7 guest communication", "Every message, review and issue handled by our team, in multiple languages."],
              ["📈", "Dynamic pricing", "Peak and off-season rates optimized every week to maximize your income."],
              ["🔑", "Check-in & check-out", "We coordinate guest arrivals, key handover and turnover cleaning."],
              ["🛏️", "Listing management", "Your property listed and synced across Booking.com, Airbnb and more."],
              ["🛡️", "Vetted guests", "We screen bookings to protect your property and your peace of mind."],
            ].map(([icon, title, desc]) => (
              <div className="fo-service-card" key={title}>
                <div className="fo-service-icon">{icon}</div>
                <h3 className="fo-service-title">{title}</h3>
                <p className="fo-service-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALCULATOR */}
      <div id="calculator">
        <EarningsCalculator />
      </div>

      {/* HOW IT WORKS */}
      <section className="fo-steps">
        <div className="fo-container">
          <div className="fo-section-eyebrow">How it works</div>
          <h2 className="fo-section-title">Three steps to start earning</h2>
          <div className="fo-steps-row">
            {[
              ["01", "Tell us about your property", "Use the calculator above or message us. We'll give you an honest estimate and a free review."],
              ["02", "We list and manage it", "Photography, listing, pricing, guests — we set everything up and take over the day-to-day."],
              ["03", "You earn, stress-free", "Bookings come in, guests are cared for, and your income lands in your account."],
            ].map(([num, title, desc]) => (
              <div className="fo-step-card" key={num}>
                <div className="fo-step-num">{num}</div>
                <h3 className="fo-step-title">{title}</h3>
                <p className="fo-step-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="fo-cta">
        <div className="fo-container fo-cta-inner">
          <div className="fo-section-eyebrow" style={{ justifyContent: "center" }}>Ready when you are</div>
          <h2 className="fo-cta-title">Let's see what your property can do</h2>
          <p className="fo-cta-sub">A free 15-minute review, no commitment. We'll tell you honestly whether we'd manage it.</p>
          <div className="fo-cta-btns">
            <a className="fo-cta-wa" href={`https://wa.me/${WA_NUM}?text=${encodeURIComponent("Hello BookingAlb! I'd like a free property review.")}`} target="_blank" rel="noreferrer">
              Message us on WhatsApp
            </a>
            <button className="fo-cta-ghost" onClick={() => navigate("/contact")}>Contact form</button>
          </div>
        </div>
      </section>

    </div>
  );
}